// Category-specific fallback images for ads without photos
// Each category has 20 unique images from Unsplash for visual variety
const categoryFallbackImages = {
  'vehicles': [
    'https://images.unsplash.com/photo-1494976388531-d1058494cdd8?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1542362567-b07e54358753?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1553440569-bcc63803a83d?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1544636331-e26879cd4d9b?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1580273916550-e323be2ae537?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1549317661-bd32c8ce0afa?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1583121274602-3e2820c69888?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1493238792000-8113da705763?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1502877338535-766e1452684a?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1526726538690-5cbf956ae2fd?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1517524008697-84bbe3c3fd98?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1597007030471-f26863e8de74?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1596768142858-1eac2d2a6e6f?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1619682817481-e994891cd1f5?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?w=400&h=300&fit=crop',
  ],
  'real-estate': [
    'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1416331108676-a22ccb276e35?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1600573472592-401b489a3cdc?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1586105251261-72a756497a11?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1560185127-6ed189bf02f4?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1600566752355-35792bedcfea?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1558036117-15d82a90b9b1?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=400&h=300&fit=crop',
  ],
  'jobs': [
    'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1551836022-deb4988cc6c0?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1553877522-43269d4ea984?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1556761175-4b46a572b786?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1488190211105-8b0e65b80b4e?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1531482615713-2afd69097998?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1574607383476-f517f260d30b?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1497215842964-222b430dc094?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1540554739023-d9a54c5a6a3a?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1579226905180-636b76d96082?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=400&h=300&fit=crop',
  ],
  'machinery': [
    'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1581244277943-fe4a9c777189?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1565043666747-69f6646db940?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1602860231618-75e03e8d9ef2?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1563398790-63d63dc3581f?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=400&h=300&fit=crop&q=80',
    'https://images.unsplash.com/photo-1590479773265-7464e5d48118?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1625722637563-1dab3ecb08e6?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=400&h=300&fit=crop&q=75',
    'https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1569003339405-ea396a5a8a90?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400&h=300&fit=crop&q=75',
    'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1518770660439-4636190af475?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1611117775350-ac3950990b70?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=400&h=300&fit=crop',
  ],
  'electronics': [
    'https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1593642632559-0c6d3fc62b89?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1546868871-af0de0ae72be?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1588872657578-7efd1f1555ed?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1585792180666-f7347c490ee2?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1468495244123-6c6c332eeece?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1550009158-9ebf69173e03?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1592286927505-1def25115558?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1598327105666-5b89351aff97?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1558089687-f282ffcbc126?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1555375771-14b2a63968a9?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1491933382434-500287f9b54b?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1560343090-f0409e92791a?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1539803700267-c44a01b0db33?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1629131726692-1accd0c53ce0?w=400&h=300&fit=crop',
  ],
  'pets': [
    'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1543466835-00a7907e9de1?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1415369629372-26f2fe60c467?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1548199973-03cce0bbc87b?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1586671267731-da2cf3ceeb80?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1537151625747-768eb6cf92b2?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1425082661507-6af0db436773?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1517849845537-4d257902454a?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1592194996308-7b43878e84a6?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1574158622682-e40e69881006?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1583511655857-d19b40a7a54e?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1601758228041-f3b2795255f1?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1450778869180-e77d2a93d8f5?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1561037404-61cd46aa615b?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1560807707-8cc77767d783?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1606567595334-d39972c85dbe?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1573865526739-10659fec78a5?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1596854407944-bf87f6fdd49e?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1444212477490-ca407925329e?w=400&h=300&fit=crop',
  ],
  'furniture': [
    'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1506439773649-6e0eb8cfb237?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1567538096630-e0c55bd6374c?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1540574163026-643ea20ade25?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1594026112284-02bb6f3352fe?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1550226891-ef816aed4a98?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1519710164239-da123dc03ef4?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1618220179428-22790b461013?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1533090161767-e6ffed986c88?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1538688525198-9b88f6f53126?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1592078615290-033ee584e267?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1574643156929-51fa098b0394?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=400&h=300&fit=crop',
  ],
  'antiques': [
    'https://images.unsplash.com/photo-1513519245088-0e12902e35ca?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1504198266287-1659872e6590?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1541123603104-512919d6a96c?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1578500494198-246f612d3b3d?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1617575521317-d2974f3b56d2?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1555169062-013468b47731?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1526817388474-07e4b6bfce53?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1561715276-a2d087060f1d?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1582735689369-4fe89db7114c?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1551405780-03882d5a2ba7?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=400&h=300&fit=crop&q=75',
    'https://images.unsplash.com/photo-1577083287937-5cbf13aeff4f?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1565193566173-7a0ee3dbe261?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1544963026-a2b5f0b0768d?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1528372444006-1bfc81acab02?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1552960394-c81add8de6b8?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1595428774223-ef52624120d2?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1579541513287-3f17a5155043?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1553877522-43269d4ea984?w=400&h=300&fit=crop&q=75',
  ],
  'beauty': [
    'https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1571781926291-c477ebfd024b?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1512496015851-a90fb38ba796?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1631214524020-7e18db9a8f92?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1598440947619-2c35fc9aa908?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1583209814683-c023dd293cc6?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1540555700478-4be289fbec6c?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1526045478516-99145907023c?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1571646034647-52e6ea84b28c?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1599305445671-ac291c95aaa9?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1586882829491-b81178aa622e?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1571875257727-256c39da42af?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1598452963314-b09f397a5c48?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1519735777090-ec97162dc266?w=400&h=300&fit=crop',
  ],
  'services': [
    'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1556761175-4b46a572b786?w=400&h=300&fit=crop&q=75',
    'https://images.unsplash.com/photo-1560264280-88b68371db39?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1556155092-490a1ba16284?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1434626881859-194d67b2b86f?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1553877522-43269d4ea984?w=400&h=300&fit=crop&q=80',
    'https://images.unsplash.com/photo-1560472355-536de3962603?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=400&h=300&fit=crop&q=75',
    'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1551836022-deb4988cc6c0?w=400&h=300&fit=crop&q=75',
    'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=400&h=300&fit=crop&q=75',
    'https://images.unsplash.com/photo-1573167507387-6b4b98cb7c13?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=400&h=300&fit=crop',
  ],
  'apparels': [
    'https://images.unsplash.com/photo-1523381210434-271e8be1f52b?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1556905055-8f358a7a47b2?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1558171813-4c088753af8f?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1445205170230-053b83016050?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1489987707025-afc232f7ea0f?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1483985988355-763728e1935b?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=400&h=300&fit=crop&q=80',
    'https://images.unsplash.com/photo-1539109136881-3be0616acf4b?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1576566588028-4147f3842f27?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1551232864-3f0890e580d9?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1562157873-818bc0726f68?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1596755094514-f87e34085b2c?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1479064555552-3ef4979f8908?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1434389677669-e08b4cda3a56?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1549298916-b41d501d3772?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1603251579431-8e48782d3dce?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1512436991641-6745cdb1723f?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=400&h=300&fit=crop',
  ],
  'boats': [
    'https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1559056199-641a0ac8b55e?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1575377427642-087cf684f29d?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1540946485063-a40da27545f8?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1598281693837-55e1a7361f5b?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1526413232644-8a40f03cc03b?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1514649923863-ceaf75b7ec40?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1560507074-b9eb1de tried?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1528154291023-a6525fabe5b4?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1504715559622-da39bc2b5cd1?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1516728778615-2d590ea1855e?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1582640906218-c40ac42e51ec?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1563200049-de43af746ba8?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1517457210348-703079e57d4b?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1506015391gy-bd29a4c?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1520473378652-85d9c4aee6cf?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1540946485063-a40da27545f8?w=400&h=300&fit=crop&q=75',
    'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&h=300&fit=crop',
  ],
  'jewellery': [
    'https://images.unsplash.com/photo-1515562141589-67f0d999b439?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1603561596112-0a132b757442?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1573408301185-9146fe634ad0?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1602751584552-8ba73aad10e1?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1596944924616-7b38e7cfac36?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1588444837495-c6cfeb53f32d?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1612817159949-195b6eb9e31a?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1601121141461-9d6647bca1ed?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1543294001-f7cd5d7fb516?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1610694955371-d4a3e0ce4b52?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1609587312208-cea54be969e7?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1626784215021-2e39ccf971cd?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1548169874-53e85f753f1e?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1606760227091-3dd870d97f1d?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1617038260897-41a1f14a8ca0?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1600721391776-b5cd0e0048f9?w=400&h=300&fit=crop',
  ],
  'phones': [
    'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=400&h=300&fit=crop&q=80',
    'https://images.unsplash.com/photo-1556656793-08538906a9f8?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1592899677977-9c10ca588bbd?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1580910051074-3eb694886571?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1598327105666-5b89351aff97?w=400&h=300&fit=crop&q=80',
    'https://images.unsplash.com/photo-1601784551446-20c9e07cdbdb?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1565849904461-04a58ad377e0?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1510557880182-3d4d3cba35a5?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1585060544812-6b45742d762f?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1574944985070-8f3ebc6b79d2?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1512054502232-10a0a035d672?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1605236453806-6ff36851218e?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1567581935884-3349723552ca?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1546054454-aa26e2b734c7?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1618478594486-c65b899c4936?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1570101945621-945409a6370f?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1558909999-1dc8e9e2d5f4?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1609692814857-de92e99a66f2?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1604671801908-6f0c6a092c05?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1584438784894-089d6a62b8fa?w=400&h=300&fit=crop',
  ],
  'music': [
    'https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1507838153414-b4b713384a76?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1510915361894-db8b60106cb1?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1513883049090-d0b7439799bf?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1525201548942-d8732f6617a0?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1524578271613-d550eacf6090?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1558098329-a11cff621064?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1545078228-89fade51ef7f?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1508854710579-5cecc3a9ff17?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1571330735066-03aaa9429d89?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1564186763535-ebb21ef5277f?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1520523839897-bd0b52f945a0?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1461784121038-f088ca1e7714?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1487180144351-b8472da7d491?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1484876065684-b683cf17d276?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1550184658-ff6132a71714?w=400&h=300&fit=crop',
    'https://images.unsplash.com/photo-1459749411175-04bf5292ceea?w=400&h=300&fit=crop',
  ],
};

// Default fallback for any unlisted category
const defaultFallbacks = [
  'https://images.unsplash.com/photo-1557821552-17105176677c?w=400&h=300&fit=crop',
  'https://images.unsplash.com/photo-1472851294608-062f824d29cc?w=400&h=300&fit=crop',
  'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=400&h=300&fit=crop&q=75',
  'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=400&h=300&fit=crop&q=75',
  'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=300&fit=crop',
  'https://images.unsplash.com/photo-1556742400-b5b7c512f3f2?w=400&h=300&fit=crop',
  'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400&h=300&fit=crop&q=75',
  'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=400&h=300&fit=crop&q=75',
  'https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=400&h=300&fit=crop&q=80',
  'https://images.unsplash.com/photo-1434389677669-e08b4cda3a56?w=400&h=300&fit=crop&q=80',
  'https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?w=400&h=300&fit=crop',
  'https://images.unsplash.com/photo-1526170375885-4d8ecf77b99f?w=400&h=300&fit=crop',
  'https://images.unsplash.com/photo-1503602642458-232111445657?w=400&h=300&fit=crop',
  'https://images.unsplash.com/photo-1468495244123-6c6c332eeece?w=400&h=300&fit=crop&q=80',
  'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=400&h=300&fit=crop&q=80',
  'https://images.unsplash.com/photo-1560343090-f0409e92791a?w=400&h=300&fit=crop&q=80',
  'https://images.unsplash.com/photo-1586882829491-b81178aa622e?w=400&h=300&fit=crop&q=80',
  'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=400&h=300&fit=crop',
  'https://images.unsplash.com/photo-1560769629-975ec94e6a86?w=400&h=300&fit=crop',
  'https://images.unsplash.com/photo-1583394838336-acd977736f90?w=400&h=300&fit=crop',
];

export const getCategoryFallbackImage = (categoryId, index = 0) => {
  const images = categoryFallbackImages[categoryId] || defaultFallbacks;
  return images[index % images.length];
};

export default categoryFallbackImages;
